module.exports = __webpack_public_path__ + "static/img/tuijian.8107303.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/tuijian.svg
// module id = 4EvE
// module chunks = 66